import type { FaireProductEntity } from "../../entity_types/product";

export const p_4o5x07se: FaireProductEntity = {
  token: "p_4o5x07se",
  type: "product",
  name: "Candle - Sicilian Orange Blossom - 170g",
  brandToken: "b_8pygbzi7",
  brandName: "FABLERUNE",
  imageUrl:
    "https://cdn.faire.com/fastly/c9e3d0b08ccd380a7564c785b87b76a8c3c58818a56fea8a62b20a2c5fdc8241.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c062cd3ef77081b9bcfafe353ac139b6432a632dac4ad42652a6396a73c9bb09.png",
  ],
  priceDollars: 13,
  description:
    "Made on the Central Coast of California, with soy wax blends and a mix of fine fragrance and essential oils.  Our candles burn clean, are vegan, cruelty-free, and phthalate-free.\n\nStep into solar light and fragrant blossoms with our Sicilian Orange Blossom scent - an offering rooted in memory and scented with intention.\n\nThe fragrance opens with sparkling top notes of petitgrain and citrus blossoms - bright, juicy, and effervescent, like morning dew on citrus leaves. In the heart, ethereal petals of jasmine entwine with luminous neroli, weaving a delicate floral bouquet both sweet and fresh. Warm base notes of sandalwood and cooling eucalyptus anchor the scent, soft woods and verdant green that deepen the aroma while keeping it airy and serene. Balanced with essential oils of bergamot and eucalyptus, the blend is lush yet clear, perfect for spring, summer, or any time your space longs for uplifting.\n\nTop: Petitgrain, Citrus Blossom\nMiddle: Jasmine, Neroli\nBase: Sandalwood, Eucalyptus\n\nPackaging:\nGlass Jar + Bamboo Cap\n\nIngredients:\nSoy Wax, Coconut Wax, Cotton Wick, Pure Essential Oils & Clean Fragrance.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:07.519Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
